import { render } from "./PricingStrategyNameDaysComponent.vue?vue&type=template&id=7d373b27&scoped=true&ts=true"
import script from "./PricingStrategyNameDaysComponent.vue?vue&type=script&lang=ts"
export * from "./PricingStrategyNameDaysComponent.vue?vue&type=script&lang=ts"

import "./PricingStrategyNameDaysComponent.vue?vue&type=style&index=0&id=7d373b27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d373b27"]])

export default __exports__